import { Box, IconButton, Text } from '@nimbus-ds/components';
import { DataList } from '@nimbus-ds/patterns';
import { Repeater } from 'commons/components';

function RowSkeleton() {
  return (
    <DataList.Row backgroundColor="transparent">
      <Box display="flex" flexDirection="column" alignItems="stretch" gap="3">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Text.Skeleton width="150px" height="16px" />
          <Box display="flex" justifyContent="flex-end" gap="2">
            <IconButton.Skeleton width="2rem" height="2rem" />
          </Box>
        </Box>
        <Text.Skeleton width="80px" height="16px" />
      </Box>
    </DataList.Row>
  );
}

const itemSkeleton = () => <RowSkeleton />;

export function MetaplansListMobileSkeleton() {
  return <Repeater times={4} item={itemSkeleton} />;
}
